import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { APPEARANCES } from '../../constants';

const Tab = forwardRef(
  ({ appearance, active = false, disabled = false, label, noBackground = false, onClick }, ref) => {
    const classes = classNames('ws-ui-tab', `ws-ui-tab--${appearance}`, {
      'ws-ui-tab--active': active,
      'ws-ui-tab--no-background': noBackground,
    });

    return (
      <button
        ref={ref}
        className={classes}
        role="tab"
        disabled={disabled}
        onClick={onClick}
        data-active={active}
      >
        <span className="ws-ui-tab__label-wrapper">{label}</span>
      </button>
    );
  }
);

Tab.displayName = 'Tab';

Tab.propTypes = {
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)).isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  noBackground: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Tab;
